<template>
	<div 
	class="form-group" 
	:class="formGroupClass">
		<form-label 
		v-if="label" 
		:for="id">
			{{label}}
		</form-label>

		<input 
		ref="input" 
		:id="id"
		:type="type" 
		:value="val" 
		v-bind="$attrs" 
		@input="input"
		class="form-control" 
		:class="{
			'is-invalid': $hasErrors(errors), 
			'border-0': !border
		}" />
		
		<form-errors v-if="errors" v-bind="{errors}" />
	    
	</div>
</template>

<script>

	import { mapState } from 'vuex'

	export default {

		props: {
			id: {
				type: String,
				default() {
					return `input-text-${this._uid}`
				},
			},

			formGroupClass: {
				type: [String, Array],
				default: ''
			},

			type: {
				type: String,
				default: 'text',
			},

			errors: {
  				type: String,
 				default: "",
  			},

			border: {
				type: Boolean,
				default: true
			},

			value: [String, Number, Object, Array, Boolean],
			label: String,
		},

		computed: {

			val() {
				return this.value
			}

		},

		methods: {

			input(event) {
				this.$emit(
					'input', 
					event.target ? event.target.value : event
				)
			}
		},
	}

</script>